





































import { Vue, Component, Prop } from 'vue-property-decorator';

import Avatar from '~/components/cards/Avatar.vue';
import CheckSolid from '~/components/icons/CheckSolid.vue';
import RateSelector from '~/components/partials/RateSelector.vue';

@Component({
  components: { Avatar, CheckSolid, RateSelector },
})
export default class Review extends Vue {
  @Prop(Object) rating: Types.Rating;
}
